/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Sections_Giveawayoffers1Inputs */

const id_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penawaran Giveaway`)
};

const ms_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawaran Pemberian`)
};

const da_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway Tilbud`)
};

const de_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway-Angebote`)
};

const en_us2_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway Offers`)
};

const es_es2_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos gratuitos`)
};

const es_mx2_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos gratuitos`)
};

const fil_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Offer na Giveaway`)
};

const fr_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offres gratuites`)
};

const it_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerte giveaway`)
};

const hu_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajándék ajánlatok`)
};

const nl_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway-aanbiedingen`)
};

const no_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giveaway-tilbud`)
};

const pl_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darmowe gry`)
};

const pt_br2_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos grátis`)
};

const pt_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas grátis`)
};

const ro_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferte gratuite`)
};

const fi_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmaistarjoukset`)
};

const sv_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratiserbjudanden`)
};

const vi_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ưu đãi tặng miễn phí`)
};

const tr_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedava Oyun Teklifleri`)
};

const cs_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabídky výprodejů`)
};

const bg_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оферти за безплатни игри`)
};

const ru_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предлагаемые раздачи`)
};

const uk_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безкоштовні пропозиції`)
};

const ar_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عروض الهدايا`)
};

const hi_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गिवअवे ऑफ़र`)
};

const th_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอของแจกฟรี`)
};

const ja_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配布オファー`)
};

const zh_cn2_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赠送目录项`)
};

const zh_hant1_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`贈送目錄項目`)
};

const ko_home_sections_giveawayoffers1 = /** @type {(inputs: Home_Sections_Giveawayoffers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 배포 오퍼`)
};

/**
* | output |
* | --- |
* | "Giveaway Offers" |
*
* @param {Home_Sections_Giveawayoffers1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_sections_giveawayoffers1 = /** @type {((inputs?: Home_Sections_Giveawayoffers1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Sections_Giveawayoffers1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_sections_giveawayoffers1(inputs)
	if (locale === "ms") return ms_home_sections_giveawayoffers1(inputs)
	if (locale === "da") return da_home_sections_giveawayoffers1(inputs)
	if (locale === "de") return de_home_sections_giveawayoffers1(inputs)
	if (locale === "en-US") return en_us2_home_sections_giveawayoffers1(inputs)
	if (locale === "es-ES") return es_es2_home_sections_giveawayoffers1(inputs)
	if (locale === "es-MX") return es_mx2_home_sections_giveawayoffers1(inputs)
	if (locale === "fil") return fil_home_sections_giveawayoffers1(inputs)
	if (locale === "fr") return fr_home_sections_giveawayoffers1(inputs)
	if (locale === "it") return it_home_sections_giveawayoffers1(inputs)
	if (locale === "hu") return hu_home_sections_giveawayoffers1(inputs)
	if (locale === "nl") return nl_home_sections_giveawayoffers1(inputs)
	if (locale === "no") return no_home_sections_giveawayoffers1(inputs)
	if (locale === "pl") return pl_home_sections_giveawayoffers1(inputs)
	if (locale === "pt-BR") return pt_br2_home_sections_giveawayoffers1(inputs)
	if (locale === "pt") return pt_home_sections_giveawayoffers1(inputs)
	if (locale === "ro") return ro_home_sections_giveawayoffers1(inputs)
	if (locale === "fi") return fi_home_sections_giveawayoffers1(inputs)
	if (locale === "sv") return sv_home_sections_giveawayoffers1(inputs)
	if (locale === "vi") return vi_home_sections_giveawayoffers1(inputs)
	if (locale === "tr") return tr_home_sections_giveawayoffers1(inputs)
	if (locale === "cs") return cs_home_sections_giveawayoffers1(inputs)
	if (locale === "bg") return bg_home_sections_giveawayoffers1(inputs)
	if (locale === "ru") return ru_home_sections_giveawayoffers1(inputs)
	if (locale === "uk") return uk_home_sections_giveawayoffers1(inputs)
	if (locale === "ar") return ar_home_sections_giveawayoffers1(inputs)
	if (locale === "hi") return hi_home_sections_giveawayoffers1(inputs)
	if (locale === "th") return th_home_sections_giveawayoffers1(inputs)
	if (locale === "ja") return ja_home_sections_giveawayoffers1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_sections_giveawayoffers1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_sections_giveawayoffers1(inputs)
	return ko_home_sections_giveawayoffers1(inputs)
});
export { home_sections_giveawayoffers1 as "home.sections.giveawayOffers" }